export default "__VITE_ASSET__BO$Ae6ve__"